import WindAssetModule from "./WindAssetModule";

const getters =
{
	/**
	 * @summary Obtém os complexos de uma empresa.
	 * @returns Conjunto de complexos existentes para a empresa.
	 */
	getComplexes()
	{
		const complexes = WindAssetModule.state.windMonitoringElementsTree.map(complex =>
		{
			return {
				id:   complex.id,
				name: complex.name,
			};
		});
		return complexes;
	},

	/**
	 * @summary Obtém os parques de uma empresa.
	 * @returns Conjunto de parques existentes para a empresa.
	 */
	getParks()
	{
		const parks = WindAssetModule.state.windMonitoringElementsTree
			.flatMap(complex => complex.windParks)
			.map(park =>
			{
				return {
					id:           park.id,
					complexId:    park.complexId,
					name:         park.name,
					windTurbines: park.windTurbines
				};
			});
		return parks;
	},

	/**
	 * @summary Obtém as turbinas de uma empresa.
	 * @returns Conjunto de turbinas existentes para a empresa.
	 */
	getTurbines()
	{
		const turbines = WindAssetModule.state.windMonitoringElementsTree
			.flatMap(complex => complex.windParks)
			.flatMap(parks => parks.windTurbines)
			.map(turbine =>
			{
				return {
					id:     turbine.id,
					parkId: turbine.parkId,
					name:   turbine.name,
					type:   turbine.turbineType
				};
			});
		return turbines;
	},
};

export default { getters };